export default "__VITE_ASSET__fb579fe9__"